var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('span',{staticStyle:{"color":"#00ff96"}},[_vm._v("2小时雨量预报")]),_c('span',{staticClass:"time",staticStyle:{"color":"#dfdfdf"}},[_vm._v(_vm._s(_vm.updateTime)+" 更新")])]),_c('div',{attrs:{"id":"rain-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }